import React, { Component } from 'react'
import { Table } from 'antd'
import moment from 'moment'

class ListTransmittals extends Component {
  getColumns = () => {
    return [
      {
        title: 'Id',
        dataIndex: 'job',
        render: item => {
          if (item && item.job_type) {
            let jobUrl = `/jobView/${item.job_id}/${item.job_type.replace(
              '/',
              '-'
            )}/transmittals/modal/${item.id}`
            return (
              <a href={jobUrl} target="_blank">
                {item.id}
              </a>
            )
          }
        }
      },
      {
        title: 'Number',
        dataIndex: 'number'
      },
      {
        title: 'Description',
        dataIndex: 'description'
      },
      {
        title: 'Status',
        dataIndex: 'status'
      },
      {
        title: 'Created Date',
        dataIndex: 'created_date'
      }
    ]
  }

  getData = () => {
    const { transmittals } = this.props

    const data = transmittals.map((transmittal, index) => {
      // format date from db
      transmittal.created_date = moment(new Date(transmittal.created_date)).format('YYYY-MM-DD')
      const returnObj = Object.assign(
        {
          key: `${transmittal.id}${index}`,
          job: {
            job_id: transmittal.job_id,
            job_type: transmittal.job_type,
            id: transmittal.id
          }
        },
        transmittal
      )
      return returnObj
    })
    return data
  }

  render() {
    return (
      <div>
        <h6>Transmittals</h6>
        <Table
          pagination={false}
          columns={this.getColumns()}
          dataSource={this.getData()}
          size="small"
          style={{ backgroundColor: 'white' }}
        />
      </div>
    )
  }
}

export default ListTransmittals



// WEBPACK FOOTER //
// ./src/components/reports/general/open-items/ListTransmittals.js